module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"videoCall":"Создать видеозвонок"}}')
  delete Component.options._Ctor
}
